module.exports = __webpack_public_path__ + "img/timevallee_0.dcf2f774.webp";